import { render, staticRenderFns } from "./shiftDialog.vue?vue&type=template&id=3fe955ad&scoped=true"
import script from "./shiftDialog.vue?vue&type=script&lang=js"
export * from "./shiftDialog.vue?vue&type=script&lang=js"
import style0 from "./shiftDialog.vue?vue&type=style&index=0&id=3fe955ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe955ad",
  null
  
)

export default component.exports